import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { DimensionInput } from "@circle-react-shared/BuilderUI/Editor/fields/DimensionInput";
import { Sizing as SizingField } from "@circle-react-shared/BuilderUI/Editor/fields/Sizing";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { EditorCollapsable } from "../../../../Editor/EditorCollapsable";

export const Sizing = () => {
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  if (isPropertiesPanelV2) {
    return (
      <EditorCollapsable
        title={t("builder_ui.prop_type.styles.size")}
        defaultOpen
      >
        <div className="px-6 py-4">
          <SizingField />
        </div>
      </EditorCollapsable>
    );
  }

  return (
    <EditorCollapsable
      title={t("builder_ui.prop_type.styles.size")}
      defaultOpen
    >
      <div className="px-6 pb-5">
        <div
          className={classNames({
            "grid grid-cols-2 gap-x-4": !isPropertiesPanelV2,
            "flex flex-col gap-2": isPropertiesPanelV2,
          })}
        >
          <DimensionInput
            name="styles.sizing.width"
            label={t("builder_ui.prop_type.styles.width")}
          />
          <DimensionInput
            name="styles.sizing.height"
            label={t("builder_ui.prop_type.styles.height")}
          />
          <DimensionInput
            name="styles.sizing.minWidth"
            label={t("builder_ui.prop_type.styles.min_width")}
          />
          <DimensionInput
            name="styles.sizing.minHeight"
            label={t("builder_ui.prop_type.styles.min_height")}
          />
          <DimensionInput
            name="styles.sizing.maxWidth"
            label={t("builder_ui.prop_type.styles.max_width")}
          />
          <DimensionInput
            name="styles.sizing.maxHeight"
            label={t("builder_ui.prop_type.styles.max_height")}
          />
        </div>
      </div>
    </EditorCollapsable>
  );
};
